"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
export function useEscapeKey(enabled, onEscape) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== enabled || $[1] !== onEscape) {
    t0 = () => {
      if (!enabled) {
        return;
      }
      const handler = e => {
        if (e.key === "Escape") {
          onEscape();
        }
      };
      window.addEventListener("keydown", handler);
      return () => window.removeEventListener("keydown", handler);
    };
    t1 = [enabled, onEscape];
    $[0] = enabled;
    $[1] = onEscape;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}